/* The QR code on the Design Studio letter preview.  v2.

   v1 shipped a static SVG in which every module was a <use> element pointing at
   a <rect> in <defs>, and the href attribute never made it into the output. So
   all 585 <use> elements resolved to nothing and only the three eyes, which
   were drawn separately, appeared. Three corners and an empty middle. v1 also
   painted a white background rect, which sat as a hard white square on the
   cream letter.

   v2 carries the module grid as a 232 character base64 string and draws it at
   run time, which is both far smaller than the expanded markup and impossible
   to corrupt by hand editing. No background: the modules sit straight on the
   paper.

   The code encodes https://rockkt.com/pages/landing-pages at error correction
   level H, with a four module quiet zone. The rendered SVG was decoded back to
   that URL in a browser before shipping.

   To change the URL you must regenerate GRID as well; it is the QR itself, not
   a decoration. Keep error correction at H and decode the render before it goes
   anywhere near a real send. A QR that looks right and does not scan is worse
   than no QR at all. */
(function () {
  var N = 37;                 /* modules per side, QR version 5 */
  var Q = 4;                  /* quiet zone, in modules */
  var SIDE = N + Q * 2;       /* 45 */
  var GRID = '/vIXA/wWYKXQbrQBxrt0FknF26SJWC7BYV0NB/qqqq/gF7LFADqxXAc7qVP76guU+tjWSEblVi9oc2Zv5pcadrCKu9nXaR6n1TIPIdrmr80GO0MltrMHDtrPEVYOMVHuf+DyNeCIODMRyG0hmHije0pworSJLyCaLYOe9OcorxYqOTsW3/6AY1nMQ/mNqCtwQD9hErrvjn+11T12Fy6oox0LBKghNx/hY65DgA==';

  function bits(b64) {
    var raw = atob(b64), out = new Uint8Array(N * N), i = 0;
    for (var byteIndex = 0; byteIndex < raw.length; byteIndex++) {
      var v = raw.charCodeAt(byteIndex);
      for (var bit = 7; bit >= 0; bit--) {
        if (i < out.length) out[i++] = (v >> bit) & 1;
      }
    }
    return out;
  }

  /* The three eyes are drawn as one ring plus one solid centre rather than as
     49 separate modules each, so they stay crisp at print size. Their squares
     are therefore skipped in the module loop. */
  function isEye(r, c) {
    return (r < 7 && c < 7) || (r < 7 && c >= N - 7) || (r >= N - 7 && c < 7);
  }

  function build() {
    var g = bits(GRID);
    var s = '<svg viewBox="0 0 ' + SIDE + ' ' + SIDE + '" xmlns="http://www.w3.org/2000/svg"'
          + ' role="img" aria-label="QR code to a Rockkt Landing Pad">'
          + '<defs><linearGradient id="rkqg" x1="0" y1="1" x2="1" y2="0">'
          + '<stop offset="0" stop-color="#1e72b8"/><stop offset="1" stop-color="#0a0f1c"/>'
          + '</linearGradient></defs>';

    var eyes = [[0, 0], [0, N - 7], [N - 7, 0]];
    for (var e = 0; e < eyes.length; e++) {
      var er = eyes[e][0] + Q, ec = eyes[e][1] + Q;
      s += '<rect x="' + (ec + 0.5) + '" y="' + (er + 0.5) + '" width="6" height="6"'
         + ' fill="none" stroke="url(#rkqg)" stroke-width="1"/>'
         + '<rect x="' + (ec + 2) + '" y="' + (er + 2) + '" width="3" height="3" fill="url(#rkqg)"/>';
    }

    s += '<g fill="url(#rkqg)">';
    for (var r = 0; r < N; r++) {
      for (var c = 0; c < N; c++) {
        if (!g[r * N + c] || isEye(r, c)) continue;
        s += '<rect x="' + (c + Q + 0.04) + '" y="' + (r + Q + 0.04)
           + '" width=".92" height=".92" rx=".28"/>';
      }
    }
    return s + '</g></svg>';
  }

  var SVG = null;

  function swap() {
    var hosts = document.querySelectorAll('.ds2-qr');
    if (!hosts.length) return;
    if (SVG === null) SVG = build();
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].getAttribute('data-rk-qr') === '2') continue;
      hosts[i].setAttribute('data-rk-qr', '2');
      hosts[i].innerHTML = SVG;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', swap);
  else swap();
  /* The Design Studio panel is built on demand, so look again once settled. */
  window.addEventListener('load', function () { setTimeout(swap, 600); });
})();
